import { Observable } from 'rxjs/Observable';
import { MotorStatusMdl } from './../../../Models/MotorStatusMdl';
import { CompAttachmentsMdl } from './../../../Models/CompAttachmentsMdl';
import { LanguageService } from './../../../Services/languageService';
import { userService } from './../../../Services/userService';
import { MotorStepService } from './../../../Services/MotorStepService';
import { PayfortTransInfoModel } from './../../../Models/ProposalModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Component, ViewChild, ElementRef, Renderer } from '@angular/core';
import { MotorProposal } from '../../../Models/MotorProposal';
import { BindMdl } from '../../../Models/BindMdl';
import { restURL } from '../../../Models/restURL';
import { motorProposalService } from '../../../Services/motorProposalService';
import { ProposalRes } from '../../../Models/ProposalRes';
import * as _swal from 'sweetalert';
//import { SweetAlert } from 'sweetalert/typings/core';
import swal from 'sweetalert2';
//const swal: SweetAlert = _swal as any;
//import swal from 'sweetalert';
import { TransInfoModel } from '../../../Models/ProposalModel';
import { MotorproposalTrackingService } from '../../../Services/MotorproposalTrackingService';
import { Subscription } from 'rxjs';
declare let $: any;
import * as jsPDF from 'jspdf';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ReviewConfirm',
  templateUrl: './ReviewConfirm.html',
  styleUrls: ['./ReviewConfirm.css']
})
export class ReviewConfirm {
  public prObj: MotorProposal = new MotorProposal();
  public IBAN1: string;
  public IBAN2: string;
  public IBAN3: string;
  public IBAN4: string;
  public IBAN5: string;
  public IBAN6: string;
  public agreeTerms: boolean;
  public LngSubscription: Subscription;
  public Lng: string;
  public bindObj: BindMdl = new BindMdl();
  public isShowLoading: boolean;
  public prResObj: ProposalRes = new ProposalRes();
  public transObj: PayfortTransInfoModel = new PayfortTransInfoModel();
  public attachments: CompAttachmentsMdl = new CompAttachmentsMdl();
  public isSubmitted: boolean = false;
  public ShowHigherPositionFeild: boolean = false;
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();
  // public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  @ViewChild('txtIBAN2') txtIBAN2Element: ElementRef;
  @ViewChild('txtIBAN3') txtIBAN3Element: ElementRef;
  @ViewChild('txtIBAN4') txtIBAN4Element: ElementRef;
  @ViewChild('txtIBAN5') txtIBAN5Element: ElementRef;
  @ViewChild('txtIBAN6') txtIBAN6Element: ElementRef;
  public Insured_City: string;
  public agreeKYC: boolean;
  public agreeNatAdd: boolean;
  constructor(private translate: TranslateService, private EncriptService: motorProposalService, private router: Router, private http: HttpClient, public url: restURL, private proposalService: motorProposalService, private renderer: Renderer, private trackingObj: MotorproposalTrackingService, private stepServiceObj: MotorStepService, private userinfo: userService, private lngService: LanguageService) {
    this.stepServiceObj.setStepNum(4);
    this.bindObj = this.proposalService.getBindObj();
    this.prObj = this.proposalService.getProposalObj();
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });
    this.agreeTerms = false;
    this.Insured_City = this.bindObj.CityMasterList.filter(t => t.CITYNAME == this.prObj.addressObj.Insured_City)[0].CITYNAMEEn;
    if (this.prObj.PreferCommLang == undefined) { this.prObj.PreferCommLang = "" }
    if (this.prObj.ReferredBy == undefined) { this.prObj.ReferredBy = "" }
    if (this.prObj.PreferCommChannel == undefined) { this.prObj.PreferCommChannel = "" }
  }
  goPrev() {
    this.proposalService.saveProposalObj(this.prObj);
    this.proposalService.saveBindObj(this.bindObj);
    if (this.prObj.SelectedProductCode == "5520" && this.prObj.isCompSelected && this.prObj.vehcileObj.Vehicle_DefType == 2 && localStorage.getItem("Channel") != "Kiosk" && this.prObj.IsRenewal==false) {
      sessionStorage.setItem("CurrentRoute", "uploads");
      if (this.prObj.st.StatusCode == "S") {
        this.router.navigate(['NewDashboard/MotorProposalForm/uploads']);
      }
    }
    else {
      sessionStorage.setItem("CurrentRoute", "VehicleDetails");
      if (this.prObj.st.StatusCode == "S") {
        this.router.navigate(['NewDashboard/MotorProposalForm/VehicleDetails']);
      }
    }
  }

  goNext() {
    this.proposalService.saveProposalObj(this.prObj);
    this.proposalService.saveBindObj(this.bindObj);
    this.saveProposal();
  }
  setBankCode(IBAN) {

    if (IBAN != "" && IBAN != undefined && IBAN != null) {
      if (IBAN.length == 4) {
        let bankCode: string = IBAN.substring(0, 2)
        if (this.bindObj.bankList.filter(t => t.BankCode == bankCode).length > 0) {
          this.prObj.Bankname = bankCode;
          setTimeout(() => this.txtIBAN3Element.nativeElement.focus(), 0);
        }
        else {
          this.prObj.Bankname = "";
          setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
        }
      }
    }
  }



  downloadTermsConditions() {
    var doc = new jsPDF();
  }
  saveAttachments(attachments): boolean {
    this.isShowLoading = true;

    this.http.post<MotorStatusMdl>(this.url.baseURL + "/Proposal/SaveAttachments", attachments, this.userinfo.getHttpOptions()).toPromise().then(
      function (res) {
        this.st = res;
        this.isShowLoading = false;
      },
      function (res) {
        this.isShowLoading = false;
      });

    return true;
  }
  uploadDocs() {
    this.saveAttachments2("100");
  }
  saveAttachments2(proposalno) {

    let frontUrl: string, backUrl: string, LeftUrl: string, RightUrl: string, ChasisUrl: string;
    if (localStorage.getItem("frontUrl") != null) {
      frontUrl = localStorage.getItem("frontUrl");
    }
    if (localStorage.getItem("backUrl") != null) {
      backUrl = localStorage.getItem("backUrl");
    }
    if (localStorage.getItem("LeftUrl") != null) {
      LeftUrl = localStorage.getItem("LeftUrl");
    }
    if (localStorage.getItem("RightUrl") != null) {
      RightUrl = localStorage.getItem("RightUrl");
    }
    if (localStorage.getItem("ChasisUrl") != null) {
      ChasisUrl = localStorage.getItem("ChasisUrl");
    }
    swal(frontUrl);
    swal(backUrl);
    swal(LeftUrl);
    swal(RightUrl);
    swal(ChasisUrl);
    let fd: FormData = new FormData();
    fd.append("backImage", backUrl);
    fd.append("frontImg", frontUrl);
    fd.append("leftImg", LeftUrl);
    fd.append("rightImg", RightUrl);
    fd.append("ChasisImg", ChasisUrl);
    fd.append("ProposalNo", proposalno);
    // var header:HttpHeaders=new HttpHeaders();
    // header=header.append('Content-Type', null);
    //  header=header.append('Accept', "multipart/form-data");
    // header= header.append('enctype', 'multipart/form-data');
    // header= header.append('Accept-Encoding', 'gzip');
    // header= header.append('apiToken',sessionStorage.getItem("token"));

    let headers = new HttpHeaders();
    headers.set('Content-Type', undefined);
    headers.set('enctype', "multipart/form-data");

    this.http.post<MotorStatusMdl>(this.url.baseURL + "/Proposal/SaveAttachments", fd, { headers: headers }).toPromise().then(
      function (res) {
        this.st = res;
        //this. = false;
      },
      function (res) {
        //this.isShowLoading = false;
      });
  }
  saveProposal() {

    if (this.prObj.IBAN1 != null && this.prObj.IBAN2 != null && this.prObj.IBAN3 != null && this.prObj.IBAN4 != null && this.prObj.IBAN5 != null && this.prObj.IBAN6 != null) {
      this.prObj.IBANNumber = this.prObj.IBAN1 + this.prObj.IBAN2 + this.prObj.IBAN3 + this.prObj.IBAN4 + this.prObj.IBAN5 + this.prObj.IBAN6;
    }

    if (!this.prObj.AccountName || this.prObj.AccountName.length === 0) {
      swal(this.translate.instant("Please Enter Bank Account Holder name"));
      return;
    }

    this.prObj.IBANNumber = "SA" + this.prObj.IBANNumber;
    let regNo: string = sessionStorage.getItem("RegNo");
    this.prObj.RegNo = regNo;
    if (this.prObj.IBANNumber != null) {
      if (this.prObj.IBANNumber.length != 24) {
        this.Lng == "ar" ? swal(" رقم الايبان 24 رقم فقط ") : swal("IBAN Number must be 24 digits");
        return;
      }
      else if ((this.prObj.Bankname.length == 0 || this.prObj.Bankname == null || this.prObj.Bankname == "00")) {
        this.Lng == "ar" ? swal("اسم البنك غير صحيح ") : swal("Invalid Bank Name");
        return;

      }
      else {
        this.attachments.backImage = sessionStorage.getItem("backImg");
        this.attachments.frontImage = sessionStorage.getItem("frontImg");
        this.attachments.leftImage = sessionStorage.getItem("leftImg");
        this.attachments.rightImage = sessionStorage.getItem("rightImg");
        this.attachments.chasisImage = sessionStorage.getItem("ChasisImg");
        this.prObj.Proposal_Status = "";
        this.prObj.Proposal_Remarks = "";
        if (localStorage.getItem("Channel") == "Kiosk")
          this.prObj.IsKiosk = true;
        this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.prObj));
        this.isShowLoading = true;
        //this.http.post<PayfortTransInfoModel>(this.url.baseURL + "/Proposal/SaveProposal", this.prObj, this.userinfo.getHttpOptions()).
        this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Proposal/SaveProposal", this.objPayloadRequest, this.userinfo.getHttpOptions()).
          toPromise().then((res) => {
            this.objPayloadResponse = res;
            let objResObj: PayfortTransInfoModel = new PayfortTransInfoModel();
            objResObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
            if (objResObj.RegNo != this.prObj.RegNo) {
              swal("Invalid Response", "Technical Error: Request Object Does Not Match With Response Object", "error")
              this.router.navigate(['BeforeLogin/NewReg']);
              return;
            }
            this.transObj = objResObj;

            if (this.transObj.st.StatusCode === "S") {
              sessionStorage.setItem("NavFrom", "PR");
              sessionStorage.setItem("transObj", this.EncriptService.EncriptObject(JSON.stringify(this.transObj)));
              sessionStorage.setItem("CurrentRoute", "PayfortPayment");
              this.router.navigate(['/NewDashboard/PayfortPayment']);
            }
            else if (this.transObj.st.StatusCode === "U") {
              swal({
                title: this.translate.instant(this.transObj.st.StatusDesc),
                text: "",
                type: "info",
                background: 'white',
                customClass: 'swal-wide !important',
                width: '50%',
                confirmButtonText: this.translate.instant('Ok')
              });
              sessionStorage.setItem("CurrentRoute", "Proposals");
              this.router.navigate(['/NewDashboard/Proposals']);
            }
            else if (this.transObj.st.StatusCode === "F") {
              swal({
                title: this.translate.instant(this.transObj.st.StatusDesc),
                text: "",
                type: "info",
                background: 'white',
                customClass: 'swal-wide !important',
                width: '50%',
                confirmButtonText: this.translate.instant('Ok')
              });

            }

            this.isShowLoading = false;
          },
            (error) => {
              this.isShowLoading = false;
              this.userinfo.checkTokenStatus(error);
              this.router.navigate(['/NewDashboard/Welcome']);
            }
          )
      }
    }
    else {
      this.Lng == "ar" ? swal("الرجاء إدخال رقم الايبان للمتابعة") : swal("Please Enter IBAN Number to proceed");
    }
  }

  checkalert(ReviewConfirmForm) {
    this.isSubmitted = true;

    if (!ReviewConfirmForm) {
      return;
    }
    if (!this.agreeTerms) {
      swal(this.translate.instant("Please agree terms and conditions"));
      return;
    }
    // if(!this.agreeKYC){
    //   swal(this.translate.instant("Please check KYC Details"));
    //   return;
    // }
    if (!this.agreeNatAdd) {
      swal(this.translate.instant("Please agree National Address Declaration"));
      return;
    }
    if (!ReviewConfirmForm.valid) {
      return;
    }
    this.isSubmitted = true;
    if (this.prObj.IsHigherPosition == undefined) {
      swal("Please select Is Higher Position");
      return;
    }
    if (this.prObj.IsHigherPosition == true && this.prObj.HigherPositionCode == undefined) {
      this.prObj.HigherPositionCode = 0;
      return;
    } else if (this.prObj.IsHigherPosition == false) {
      this.prObj.HigherPositionCode = 0;
      this.saveProposal();
    } else if (this.prObj.IsHigherPosition == true && this.prObj.HigherPositionCode != undefined) {
      this.prObj.HigherPositionCode = Number(this.prObj.HigherPositionCode);
      if (ReviewConfirmForm.valid) {
        this.saveProposal();
      }
    }
  }

  IsHigherPosition(val) {
    if (val == "true") {
      this.prObj.IsHigherPosition = true;
      this.ShowHigherPositionFeild = true;
    } else {
      this.prObj.IsHigherPosition = false;
      this.ShowHigherPositionFeild = false;
    }
  }
  iban1Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 2) {
        setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
      }
    }
  }
  iban2Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        let bankCode: string = event.substring(0, 2)

        if (this.bindObj.bankList.filter(t => t.BankCode == bankCode).length > 0) {
          this.prObj.Bankname = bankCode;
          setTimeout(() => this.txtIBAN3Element.nativeElement.focus(), 0);
        }
        else {
          this.prObj.Bankname = "";
          setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);

        }
      }
    }
  }
  iban3Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN4Element.nativeElement.focus(), 0);
      }
    }
  }
  iban4Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN5Element.nativeElement.focus(), 0);
      }
    }
  }
  iban5Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN6Element.nativeElement.focus(), 0);
      }
    }
  }

  ValidateSpecialCharacters(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k > 1500 && k < 1650) || k == 8 || k == 32);
  }

  ngAfterViewInit() {

    $(document).ready(function () {

      $('[data-toggle="popover"]').popover({
        placement: 'top',
        trigger: 'hover'
      });
    });
  }

  allowEnglishOnly(event: KeyboardEvent) {
    const char = String.fromCharCode(event.keyCode);
    const pattern = /^[A-Za-z ]+$/;
    if (!pattern.test(char)) {
      swal(this.translate.instant("Please Enter English Name only"));
      event.preventDefault();
    }
  }

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/ReviewConfirm/ReviewConfirm.ts